var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "rounded-lg fill-height" },
        [
          _c("v-divider"),
          _c(
            "v-card-title",
            [_c("v-icon", [_vm._v("mdi-webhook")]), _vm._v(" Webhooks ")],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("p", [
                _vm._v(
                  "When a meeting recording is ready or a guest logs in with an email address, the data will be sent to the URLs you provide here. The data is sent in JSON format as a POST to the URL. This can be to any URL including Zapier, make.com, etc."
                ),
              ]),
              _vm.loading
                ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
                : _vm._e(),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "2" } }, [_vm._v("Title")]),
                  _c("v-col", { attrs: { cols: "4" } }, [_vm._v("URL")]),
                  _c("v-col", { attrs: { cols: "5" } }, [_vm._v("Rooms")]),
                  _c("v-col"),
                ],
                1
              ),
              _c("v-divider"),
              _vm._l(_vm.app.webhooks, function (webhook) {
                return _c("webhook", {
                  key: webhook.ID,
                  attrs: { webhook: webhook },
                })
              }),
            ],
            2
          ),
          _c("v-card-actions", { staticClass: "pb-4" }, [
            _c(
              "a",
              {
                staticClass: "dotted-underline ml-2",
                attrs: { href: "#" },
                on: { click: _vm.addWebhook },
              },
              [_vm._v("Add Webhook +")]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }